// extracted by mini-css-extract-plugin
export var contentarea = "LandingPage-module--contentarea--11413";